module.exports = __webpack_public_path__ + "static/media/STANDARD_END.068f9d86.mp3";